module.exports = __webpack_public_path__ + "img/trash-icon.svg";